import React, { ComponentType } from 'react';

import { PrimaryButtonProps } from '@atlaskit/atlassian-navigation';
import { LinkItem, CustomItem } from '@atlaskit/menu';

import { AnalyticsEvent } from 'src/components/navigation/src/types';

type Props = Omit<PrimaryButtonProps, 'onClick'> & {
  isClientLink?: boolean;
  linkComponent?: ComponentType<any>;
  publishUiEvent: (event: AnalyticsEvent) => void;
  analyticsLabel: string;
  actionSubject?: string;
  onClose?: () => void;
};

export const HorizontalNavLinkItem = React.memo((props: Props) => {
  const {
    linkComponent: LinkComponent,
    isClientLink,
    publishUiEvent,
    analyticsLabel,
    actionSubject,
    onClose,
    ...linkProps
  } = props;

  const onPublishUiEvent = () => {
    publishUiEvent({
      action: 'clicked',
      actionSubject: actionSubject || 'navigationItem',
      actionSubjectId: analyticsLabel,
      source: 'navigation',
    });
    if (onClose) {
      onClose();
    }
  };

  return isClientLink && LinkComponent ? (
    <CustomItem
      {...linkProps}
      component={LinkComponent}
      onClick={onPublishUiEvent}
    >
      {linkProps.children}
    </CustomItem>
  ) : (
    <LinkItem {...linkProps} onClick={onPublishUiEvent} />
  );
});
